export const frontendToBackendKeysMap = new Map<string, string>([
    ['Connection', 'network.connection'],
    ['IP', 'network.ip'],
    ['Netcom Transport', 'network.netcom_transport'],
    ['UDP Pusher', 'network.udp_pusher'],
    ['alimStatus', 'alim_status'],
    ['alimentation', 'alim_source'],
    ['applianceType', 'appliance_type'],
    ['autoTrigger', 'monitoring'],
    ['battery', 'battery, battery_threshold, battery_vp, mainDevice.battery_vp'],
    ['batteryDead', 'battery_dead'],
    ['batteryTemperatureLevel', 'battery_temperature_level'],
    ['boilerControl', 'boiler_control'],
    ['bubendorffMotorType', 'bubendorff_motor_type'],
    ['button', 'numberOfButtons'],
    ['command', 'commandLink'],
    ['command2', 'command2Link'],
    ['configured', 'configured'],
    ['controlledDevices', 'controlledDevice'],
    ['controlledDevicesLeft', 'controlledDevice'],
    ['controlledDevicesMiddle', 'controlledDevice'],
    ['controlledDevicesRight', 'controlledDevice'],
    ['customer', 'command2Field, commandField'],
    ['dhwControl', 'dhw_control'],
    ['energyType', 'measured_elec_type'],
    ['ergonomicId', 'ergonomics'],
    ['eventualDoubleMac', 'eventual_dble_mac'],
    ['feedbackGiven', 'feedback_given'],
    ['firmware', 'firmware, firmware_2, firmware_private, mainDevice.firmware'],
    ['firmwareName', 'firmware_name'],
    ['fullFeatureSupported', 'full_feature_supported'],
    ['fwPrivate', 'firmware_private'],
    ['groupId', 'group_id'],
    ['homekitStatus', 'homekit_status'],
    ['hwVersion', 'hw_version'],
    ['image', 'image_type'],
    ['installationIlim', 'installation_ilim'],
    ['installationVoltage', 'installation_voltage'],
    ['keyAttachments', 'keyAttachments'],
    ['lastActivity', 'last_activity'],
    ['lastCalibration', 'valve_calibration.time'],
    ['lastData', 'last_data, outdatedLastData'],
    ['lastReset', 'last_reset'],
    ['lastResetType', 'last_reset_type'],
    ['lastSeen', 'mainDevice.reachable, outdatedLastSeen, reachable'],
    ['lastSetup', 'last_setup'],
    ['lastStatusStored', 'outdatedLastStatusStored'],
    ['lastUpdate', 'last_fw_update, mainDevice.last_fw_update'],
    ['line', 'consumption_type'],
    ['lineName', 'channel'],
    ['macAddress', 'id'],
    ['macAddressZigbee', 'id, zigbee_address'],
    ['manualPairing', 'manual_pairing'],
    ['manufacturer', 'manufacturer_id'],
    ['mfgId', 'mfg_id'],
    ['migrated', 'migrated'],
    ['mode', 'measures_scope'],
    ['monitoring', 'status'],
    ['motorSpeed', 'motor_frequency'],
    ['name', 'mainDevice.name, name'],
    ['nbCharge', 'battery_charge_cnt'],
    ['notifyRule', 'notify_rule'],
    ['packagingId', 'packaging'],
    ['pidAlgoPeriod', 'pid_algo_period'],
    ['radioId', 'radio_id'],
    ['reachable', 'mainDevice.reachable, reachable'],
    ['recordRule', 'record_rule'],
    ['refurbished', 'refurb_date'],
    ['relayConnectedTo', 'network.plug_connected_boiler'],
    ['rfRating', 'rf_rating'],
    ['rfStatus', 'rf, rf_status, rf_strength'],
    ['room', 'room_id'],
    ['routerId', 'router_id'],
    ['sdStatus', 'sd_status'],
    ['setupDate', 'date_setup'],
    ['shareWeatherMap', 'public_ext_data'],
    ['sirenSoundRule', 'siren_sound_rule'],
    ['stateOfCharge', 'battery_percent'],
    ['stateOfHealth', 'battery_soh'],
    ['stationName', 'name'],
    ['status', 'status'],
    ['subline', 'channel'],
    ['subtype', 'subtype'],
    ['tamperDetection', 'tamper_detection_enabled'],
    ['thermalControl', 'shutter_thermal_control_enabled'],
    ['ticStatus', 'tic_link_state'],
    ['ticType', 'tic_version'],
    ['type', 'type, typeToDisplay'],
    ['uptime', 'uptime'],
    ['veluxType', 'velux_type'],
    ['voltageDrop', 'motor_voltage_drop'],
    ['weatherMapFilteringReason', 'weathermap_marks_data.reason'],
    ['weatherMapIsFiltered', 'weathermap_marks_data.is_filtered'],
    ['wifiChannel', 'wifi_channel'],
]);
